export type { InputProps } from './src/Input';
export type { Formatter, Parser } from './src/helpers/formatter';

export { Input as default } from './src/Input';
export { Input } from './src/Input';

export { createInputFormatter, createInputParser } from './src/helpers/formatter';
